import HowToRegIcon from '@mui/icons-material/HowToReg';
import { IntegrationContainer } from '../components/IntegrationContainer';
import { Step } from '../components/Step';
import { Step1 } from './components/Step1';
import { Step2 } from './components/Step2';
import { Step3 } from './components/Step3';
import { Step4 } from './components/Step4';
import { useA3Connection } from './hooks';
import { useTranslation } from 'react-i18next';
import { guideUrl } from './consts';

export const A3 = () => {
  const {
    selectedCompany,
    isConnected,
    resultGetSalaryType,
    resultGetCustomFields,
    showSalary,
    handleSelectedCompanyChange,
    toggleShowSalary,
    handleGetUrl
  } = useA3Connection();
  const { t } = useTranslation('settings');

  return (
    <IntegrationContainer setSelectedCompany={handleSelectedCompanyChange} guideUrl={guideUrl}>
      {selectedCompany && (
        <>
          <Step1 handleGetUrl={handleGetUrl} />
          {isConnected && (
            <>
              <Step2
                resultGetSalaryType={resultGetSalaryType}
                toggleShowSalary={toggleShowSalary}
                showSalary={showSalary}
              />
              <Step3 customFields={resultGetCustomFields} />
              <Step4 />
              <Step
                title={`${t('integrations.step')} 5`}
                subtitle={t('integrations.factorial.review the data in the view edit employees section')}
                Icon={HowToRegIcon}
              />
            </>
          )}
        </>
      )}
    </IntegrationContainer>
  );
};
